/**
 * SessionTimer — shows elapsed session time in mm:ss (JetBrains Mono).
 * Falls back to a dash when no session is active.
 */

import { useEffect, useState } from "react";

function fmt(ms) {
    const total = Math.max(0, Math.floor(ms / 1000));
    const m = Math.floor(total / 60).toString().padStart(2, "0");
    const s = (total % 60).toString().padStart(2, "0");
    return `${m}:${s}`;
}

export function SessionTimer({ startedAt }) {
    const [now, setNow] = useState(Date.now());

    useEffect(() => {
        if (!startedAt) return;
        const id = setInterval(() => setNow(Date.now()), 500);
        return () => clearInterval(id);
    }, [startedAt]);

    return (
        <div
            data-testid="session-timer"
            className="qoryn-panel rounded-full px-4 py-2 font-mono-ui text-[11px] tracking-widest text-qoryn-textDim"
        >
            {startedAt ? fmt(now - startedAt) : "—— : ——"}
        </div>
    );
}

export default SessionTimer;
